import { render, staticRenderFns } from "./PropertyTextMd.vue?vue&type=template&id=9afe3e5a&"
import script from "./PropertyTextMd.vue?vue&type=script&lang=js&"
export * from "./PropertyTextMd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports